import _ from 'lodash';
import { Component, Input, Output, EventEmitter} from '@angular/core';
import { VesselMapModel, VesselService, OceanLineModel, AlertService, VesselModel, Oper, PagerService} from 'app/services/index'
declare var $:any;

@Component({
  selector: 'vessel-map-update-list',
  templateUrl: 'vessel-map-update-list.html'
})
export class VesselMapUpdateListComponent {

    _isOpen = false;
    _vesselMapList:Array<VesselMapModel> = new Array<VesselMapModel>();
    

    operTypeList:Array<any> = new Array<any>();
    stusList:Array<any> = new Array<any>();
    scraperTypeList:Array<any> = new Array<any>();
    
    @Output() onRefresh: EventEmitter<any> = new EventEmitter();
    @Output() onClose: EventEmitter<any> = new EventEmitter();

    @Input() vesselList:Array<VesselModel> = new Array();
    @Input()operList:Array<Oper> = new Array();

    pager: any = {};
    pagedItems: any[];

    allStatus:any = null;
    
    constructor(   
        private vesselService:VesselService,
        private pagerService: PagerService,
        private alertService:AlertService
    ) {
    }

    @Input() 
    set vesselMapList(vesselMapList){
        if(!vesselMapList) return ;
        this._vesselMapList = vesselMapList;
        this.setPage(1);
    }

    get vesselMapList(){
        return this._vesselMapList;
    }


    @Input() set openFlag(flag){
        this._isOpen = true;
    }

    ngOnInit() {
        this._isOpen = false;
        this.initMake();
        // this.vesselService.oceanLineListEe.subscribe( data => {
        //     for(let ocean of this.vesselService.oceanLineList){
        //         let oper = new Oper();
        //         oper.operCd = ocean.lineCd;
        //         oper.operNm = ocean.lineNm;
        //         oper.operTpCd = 0;
        //         oper.operTpNm = 'SHIP_OPERATOR';
        //         this.operList.push(oper);
        //     }
        // });
        // this.vesselService.terminalListEe.subscribe( data => {
        //     for(let terminal of this.vesselService.terminalList){
        //         let oper = new Oper();
        //         oper.operCd = terminal.terminalCd;
        //         oper.operNm = terminal.terminalNm;
        //         oper.operTpCd = 1;
        //         oper.operTpNm = 'TERMINAL';
        //         this.operList.push(oper);
        //     }
        // });
    }

    initMake(){
        this.operTypeList.push({text:'SHIP_OPERATOR', id:'0'});
        this.operTypeList.push({text:'TERMINAL', id:'1'});
        this.operTypeList.push({text:'FORWARDER', id:'2'});

        this.stusList.push({text:'REQUEST', id:'0'});
        this.stusList.push({text:'MAPPED', id:'1'});
        this.stusList.push({text:'SKIP', id:'2'});
        this.stusList.push({text:'TEMPMAPPED', id:'3'});
        this.stusList.push({text:'CHECK', id:'4'});
        this.stusList.push({text:'NONE', id:'5'});

        this.scraperTypeList.push({text:'P2P_SCHEDULE', id:'0'});
        this.scraperTypeList.push({text:'BERTH_PLAN', id:'1'});
        this.scraperTypeList.push({text:'LCL_SCHEDULE', id:'2'});
        this.scraperTypeList.push({text:'VESSEL_SCHEDULE', id:'3'});
        this.scraperTypeList.push({text:'AIR_SCHEDULE', id:'4'});
        this.scraperTypeList.push({text:'TRACKING', id:'5'});
    }

    setPage(page: number) {
        this.pager = this.pagerService.getPager(this.vesselMapList.length, page, 5);

        // if (page < 1) {
        //     return;
        // } 

        this.pagedItems = this.vesselMapList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }

    selecedOper(event:any) {
        let oper:Oper = event.data;
        let index:number = event.index;
        if(oper) {
            this.vesselMapList[index].operCd = oper.operCd;
            this.vesselMapList[index].operTpCd = oper.operTpCd;
            this.vesselMapList[index].operTpNm = oper.operTpNm;
        } else {
            this.vesselMapList[index].operCd = null;
            this.vesselMapList[index].operTpCd = null;
            this.vesselMapList[index].operTpNm = null;
        }
    }

    selecedMapping(event:any){
        let vessel:VesselModel = event.data;
        let index:number = event.index;
        if(vessel) {
            this.vesselMapList[index].vessel = vessel;
        } else {
            this.vesselMapList[index].vessel = null;
        }
    }

    selected(values:any, type:string, index:number){
        if(type.indexOf('STATUS') > -1){
            this.vesselMapList[index].vesselMapStatusCd = Number(values.id);
            this.vesselMapList[index].vesselMapStatusNm = values.text;
        }else{
            this.vesselMapList[index].reqSystemCd = Number(values.id);
            this.vesselMapList[index].reqSystemNm = values.text;
        }
    }

    save(){
        let that = this;
        $.sweetModal.confirm('저장하시겠습니까?', function() {
            that.vesselMapList = _.map(that.vesselMapList, (vesselMap:VesselMapModel) =>{
                if(vesselMap.vesselMapStatusCd == 1 && vesselMap.vessel == null) vesselMap.vesselMapStatusCd = 0;
                return vesselMap;
            });
            that.vesselService.patchVesselMap(that.vesselMapList).subscribe(
                res =>{
                    if(res.result){
                        that.alertService.success("저장 되었습니다.");
                        that.onRefresh.emit(1);
                    }
                }
            );   

        }, function() {
        });
    }

    close(){
        this.onClose.emit();
        this.vesselMapList = null;
        this.allStatus = null;
    }

    selectStatus(values){
        this.vesselMapList = _.map(this.vesselMapList, (vesselMap:VesselMapModel) => {
            vesselMap.vesselMapStatusNm = values.text;
            vesselMap.vesselMapStatusCd = Number(values.id);
            return vesselMap;
        });
    }
}





// WEBPACK FOOTER //
// ./src/app/containers/vessel/vessel-map-update-list.ts